<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'gridcardicon',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <a-row :gutter="[30,30]">
        <a-col  :sm="getCol.sm(data.col)" :md="getCol.md(data.col)"  :lg="getCol.lg(data.col)"  v-for="(item,i) in data.child" :key="i">
            <a class="content-box text-center"  :href="item.url" >
              <div class="line"></div>
              <img class="margin-tb" :src="addip(item.icon)" :alt="item.name" style="width:128px;height:128px" />
              <h3 style="">{{ item.name }}</h3>
              <h5 v-if="item.sub">{{ item.sub }}</h5>
            </a>
        </a-col>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="gridcardicon">
import {defineComponent,defineProps } from 'vue'
import {addip,getCol} from '@/utils/util'
defineProps({
  data:Object
})
</script>
<style lang="less">
@import '@/style/main.less';
    .gridcardicon {
      .content-box {
        background-color: @white-opacity-50;
        .line{
          width:0;height:3px;
          background-color: @primary;
          position: absolute;left:0;top:0;
          transition: all .2s linear;}
      }
        .content-box:hover{
          background-color: @primary-opacity-10;
            .line {width: 100%;}
        }
    }
</style>
